import { Button } from "react-bootstrap";

const CancelButton = (props) => {
    return (
        <Button
            variant="light"
            {...props}>
            {props.children}
        </Button>
    )
}

export default CancelButton;